"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
class Session {
    constructor(cookies) {
        this.cookies = cookies;
        this.tracksCount = 1; // count of track events
        this.paramsSet = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'utm_id',
            'shortId',
            'gclid',
            'gbraid',
            'wbraid',
            'aff',
            'fbpx', // facebook pixel id
        ];
        console.log('Session init');
        this.session = this.start();
        this.initParams(); // get or cookies params
        this.initTracks();
    }
    initParams() {
        console.log('Init params, lets search query params in url');
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.params = {};
        this.paramsSet.forEach((param) => {
            let value = urlParams.get(param);
            if (value) {
                this.params[param] = value;
                const days = ['fbpx'].includes(param) ? 1 : 365;
                this.cookies.set(param, value, days);
                return;
            }
            value = this.cookies.get(param);
            if (value) {
                this.params[param] = value;
            }
        });
    }
    initTracks() {
        const tracksCount = this.cookies.get('tracks-count');
        if (tracksCount) {
            this.tracksCount = parseInt(tracksCount);
        }
    }
    getTracks() {
        return this.tracksCount;
    }
    incrementTracks() {
        this.tracksCount += 1;
        this.cookies.set('tracks-count', this.tracksCount.toString(), 1);
    }
    generateSessionId() {
        return Math.random().toString(36).substring(2, 15);
    }
    start() {
        const sessionId = this.cookies.get(Session.SESSION_COOKIE);
        if (!sessionId) {
            const newSessionId = this.generateSessionId();
            this.cookies.set(Session.SESSION_COOKIE, newSessionId, 1);
            console.log('New session started:', newSessionId);
            return newSessionId;
        }
        else {
            console.log('Existing session:', sessionId);
            return sessionId;
        }
    }
    get() {
        return this.session;
    }
    getUtm() {
        return {
            source: this.params.utm_source,
            medium: this.params.utm_medium,
            campaign: this.params.utm_campaign,
            content: this.params.utm_content,
            term: this.params.utm_term,
            id: this.params.utm_id,
        };
    }
    getGCLID() {
        return this.params.gclid || '';
    }
    getGoogleIds() {
        return {
            gclid: this.params.gclid,
            gbraid: this.params.gbraid,
            wbraid: this.params.wbraid,
        };
    }
    getShortId() {
        return this.params.shortId || '';
    }
    getParntersWebId() {
        return this.params[Session.PP_WEBID] || '';
    }
    getFacebookPixelId() {
        return this.params.fbpx;
    }
}
exports.Session = Session;
Session.SESSION_COOKIE = 'session';
Session.PP_WEBID = 'utm_content'; // webmasters id from partners network
